const endpoints = {
  PROFITLOSSREPORTOFADMIN: `profit-loss-report/admin`,
  BETLIST: `bet/bet-list`,
  BET_LIST_BY_ROUND: `bet/bet-list-by-round`,
  ACCOUNT: {
    ADD: `member/add-account`,
    updateUser: (userId: string) => `member/user-update/${userId}`,
    get_transaction_pwd: (user_id: string) => `member/set-transaction-password/${user_id}`,
  },
  game: {
    root: `api/game`,
  },
  user: {},
  member: {
    getMember: (user_id: string) => `member/get-member/${user_id}`,
    getUsernameValid: (username: string) => `member/get-username-valid/${encodeURIComponent(username)}`,
    allpanelStatistics: (user_id: string) => `member/allpanelStatistics/${user_id}`,
    getDownLineHandlerById: (user_id: string) => `member/getDownLineHandler/${user_id}`,
    operation: (user_id: string) => `member/operation/${user_id}`,
    getAccountList: (user_id: string, limit: string | number = 5, is_active: boolean = true) =>
      `member/getDownLineList/${user_id}?limit=${limit}&is_active=${is_active}`,
    allpanelDownlineList: (
      user_id: string,
      limit: number = 25,
      offset: number = 0,
      status: string = "active",
      type: string = "both",
      search: string = ""
    ) =>
      `member/allpanelDownlineList/${user_id}?limit=${limit}&offset=${offset}&type=${type}${status !== "both" ? `&status=${status}` : ""}${search ? `&search=${encodeURIComponent(search)}` : ""}`,
    marketBetList: `/admin/marketBetList`,
  },
  admin: {
    accountStatement: `admin/account-statement`,
  },
  subAdminAccounts: {
    create: "sub-admin-accounts/create",
    list: "sub-admin-accounts/list",
    update: (id: string) => `sub-admin-accounts/update/${id}`,
    status: (id: string) => `sub-admin-accounts/status/${id}`,
    changePassword: (id: string) => `sub-admin-accounts/change-password/${id}`,
  },
  business: {
    games: `business-games`,
    groupGameEvents: (groupId: string) => `event/business-group-game-events/${groupId}`,
  },
  userReport: {
    /** Lean account statement (silver-admin-FE) — no embedded bets. */
    accountStatementLean: (
      userId: string,
      startDate: number,
      endDate: number,
      reportName: string,
      limit: number = 1000,
      offset: number = 0,
      gameName?: string,
      isCasino?: boolean
    ) =>
      `user/account-statement-lean?userId=${userId}&startDate=${startDate}&endDate=${endDate}&reportName=${reportName}&limit=${limit}&offset=${offset}&sort_column=settled_at&sort_order=asc${gameName ? `&gameName=${encodeURIComponent(gameName)}` : ""}${typeof isCasino === "boolean" ? `&isCasino=${isCasino}` : ""}`,
    /** Lazy-load bets for one game row (description click). */
    accountStatementBets: (params: {
      userId: string;
      provider_market_id?: string;
      market_id?: string;
      is_casino?: boolean;
    }) => {
      const q = new URLSearchParams();
      q.set("userId", params.userId);
      if (params.provider_market_id) q.set("provider_market_id", params.provider_market_id);
      if (params.market_id) q.set("market_id", params.market_id);
      if (typeof params.is_casino === "boolean") q.set("is_casino", String(params.is_casino));
      return `user/account-statement-bets?${q.toString()}`;
    },
  },
  GAME: {
    list: `game`,
  },
  reports: {
    sportsRevenue: "reports/sports-revenue",
    profitLossGroupByMarket: "profit-loss-report/group-by-market",
    profitLossGroupByEvent: "profit-loss-report/group-by-event",
    sportSummary: "profit-loss-report/sport-summary",
    marketSettlementDetails: "profit-loss-report/market-settlement-details",
  },
  bet: {
    betList: "bet/bet-list",
    adminBetList: "bet/admin-unsettle-bet-list",
    events: "bet/events",
    marketTypes: "bet/market-types",
    markets: "bet/markets",
    masterUserPl: "bet/user-book-pl",
    place: "bet",
    agentBet: "agent-bet",
    userMarketDetail: "bet/user-market-detail",
  },
  analysis: {
    sportAnalysis: "analysis/sport-analysis",
    groupedUnsettleBets: "bet/grouped-unsettle-bets",
  },
  casino: {
    liveCasinoEvents: "event/live-casino-events",
    casinoUrl: "event/casino-url",
    openBet: (providerEventId: string) => `event/open-bet/${providerEventId}`,
  },
  MARKET_BY_EVENT: "event/market_list/:eventId",
  MARKET_BY_RACE: "event/hours-or-greyhounds-event-and-market-list",
};

export default endpoints;

// Types
export interface IMember {
  member_code: string;
  user_name: string;
  display_name?: string;
  role_id: string;
  status: string;
  member_min_bet: number;
  member_max_bet_amt: number;
  member_max_exposure_amt: number;
  created_by: string;
  is_bet_lock: boolean;
  created_at: string;
  commission_settings: CommissionSettings;
  partnership: Partnership;
  credit_reference: number;
  user_id: string;
  balance: number;
  role_name: string;
  admin_id: string;
  admin_user_name: string;
  admin_balance: number;
}

export interface CommissionSettings {
  up_line: number;
  down_line: number;
  our: number;
}

export interface Partnership {
  up_line: number;
  down_line: number;
  our: number;
}
